import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { AnalyticsService } from '../state/analytics/analytics.service';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[rdcAnalytics]',
    standalone: true,
})
export class AnalyticsDirective implements OnInit {
    @Input() rdcAnalytics: string;

    constructor(
        private analyticsService: AnalyticsService,
        private elementRef: ElementRef<HTMLElement>,
        private renderer: Renderer2
    ) {}

    ngOnInit(): void {
        this.renderer.setAttribute(
            this.elementRef.nativeElement,
            'rdcAnalytics',
            this.rdcAnalytics
        );

        this.renderer.listen(this.elementRef.nativeElement, 'click', () => {
            const analyticsDataValue =
                this.elementRef.nativeElement.getAttribute(
                    'rdcanalyticsdata'
                ) ?? undefined;
            this.analyticsService.fireEvent(
                this.rdcAnalytics,
                analyticsDataValue
            );
        });
    }
}
